import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Shield, User, Mail, Building2, LogOut, ChevronDown, Trash2, Users, Server, ScrollText, ShieldAlert, Clock, Activity } from 'lucide-react';

const SuperAdminPage = ({ onLogout }) => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(false);
  const [expandedId, setExpandedId] = useState(null);

  const fetchData = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get('https://ai-noc.skynix.co/api/master/clients', {
        headers: { 'X-NOC-Token': token }
      });
      setClients(res.data);
    } catch (e) { console.error(e); }
    setLoading(false);
  };


const handleDelete = async (id, name) => {
    if (id === 1) return alert("System restricted: Master tenant cannot be deleted.");
    
    if (window.confirm(`DANGER! Delete company "${name}" and ALL its data?`)) {
      try {
        const token = localStorage.getItem('token');
        await axios.delete(`https://ai-noc.skynix.co/api/master/clients/${id}`, {
          headers: { 'X-NOC-Token': token }
        });

        setClients(clients.filter(c => c.id !== id));
      } catch (e) { 
        alert("Delete failed: " + (e.response?.data?.detail || e.message)); 
      }
    }
};

  useEffect(() => { fetchData(); }, []);

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#0b0e14', color: '#e2e8f0' }}>
      <header className="p-4 border-bottom border-secondary d-flex justify-content-between align-items-center" style={{ background: '#0d1117' }}>
        <div className="d-flex align-items-center gap-3">
          <div className="bg-info p-2 rounded"><Shield className="text-dark" size={24} /></div>
          <h4 className="m-0 fw-bold font-mono">MASTER <span className="text-info">CONTROLLER</span></h4>
        </div>
        <button onClick={onLogout} className="btn btn-outline-danger btn-sm px-4 fw-bold">Sign Out</button>
      </header>

      <main className="p-5">
        <div className="max-w-7xl mx-auto">
          <h1 className="fw-bold m-0 text-white text-start">SaaS Clients</h1>
          <p className="text-secondary small text-start mb-5">Global platform infrastructure overview</p>

          <div className="d-flex flex-column gap-3">
            {clients.map(c => (
              <div key={c.id} className="border border-secondary rounded-3 overflow-hidden shadow-sm" style={{ background: '#151921' }}>
                
            
                <div className="p-3 d-flex align-items-center cursor-pointer hover-bg" onClick={() => setExpandedId(expandedId === c.id ? null : c.id)}>
                  <div style={{ width: '50px' }} className="text-info font-monospace small">#{c.id}</div>
                  <div style={{ width: '300px' }} className="text-start">
                    <h6 className="m-0 fw-bold text-white d-flex align-items-center gap-2">
                        <Building2 size={14} className="text-secondary"/> {c.company}
                    </h6>
                    <div className="text-secondary" style={{fontSize: '11px'}}>{c.users.length} users registered</div>
                  </div>
                  <div className="flex-grow-1 text-center">
                     <span className="badge bg-dark border border-secondary text-info uppercase" style={{ fontSize: '10px', padding: '6px 16px', borderRadius: '20px' }}>
                        {c.plan} PLAN / {c.status}
                     </span>
                  </div>
                  <div style={{ width: '100px' }} className="d-flex justify-content-end align-items-center gap-3">
                  {c.id !== 1 && (
                    <button 
                      className="btn btn-link p-0 border-0 shadow-none"
                      onClick={(e) => { 
                        e.stopPropagation(); 
                        handleDelete(c.id, c.company); 
                      }}
                    >
                      <Trash2 size={16} className="text-secondary hover-red" />
                    </button>
                  )}
                  <ChevronDown size={20} className="text-secondary" style={{ transform: expandedId === c.id ? 'rotate(180deg)' : 'none', transition: '0.3s' }} />
                </div>
                </div>

           
                {expandedId === c.id && (
                  <div className="p-4 bg-black bg-opacity-40 border-top border-secondary animate-fadeIn">
                    <div className="row g-4">
        
                      <div className="col-md-4 text-start border-end border-secondary border-opacity-20 px-4">
                        <div className="text-secondary uppercase fw-bold mb-3 d-flex align-items-center gap-2" style={{ fontSize: '10px' }}><Users size={14}/> Users</div>
                        <div className="d-flex flex-column gap-2">
                          {c.users.map((u, idx) => (
                            <div key={idx} className="p-3 rounded bg-dark border border-secondary border-opacity-30 d-flex align-items-center justify-content-between text-start mx-auto w-100" style={{ maxWidth: '800px' }}>
                                <div className="d-flex align-items-center gap-3">
                                <div className="bg-secondary bg-opacity-10 p-2 rounded-circle text-info"><User size={16}/></div>
                                <div>
                                    <div className="text-white fw-bold small">{u.name}</div>
                                    <div className="text-secondary x-small d-flex align-items-center gap-1">
                                        <Mail size={10}/> {u.email}
                                    </div>
                                   
                                    <div className="text-info x-small mt-1 d-flex align-items-center gap-1" style={{ opacity: 0.8 }}>
                                        <Clock size={10}/> Last access: {u.last_login}
                                    </div>
                                </div>
                                </div>
                                <div className="badge bg-success text-white border-0" style={{ fontSize: '9px', fontWeight: 'bold' }}>ACTIVE</div>
                            </div>
                            ))}
                          <div className="mt-2 text-info small fw-bold">Total Users: {c.users.length}</div>
                        </div>
                      </div>

             
                      <div className="col-md-3 text-start border-end border-secondary border-opacity-20 px-4">
                        <div className="text-secondary uppercase fw-bold mb-3 d-flex align-items-center gap-2" style={{ fontSize: '10px' }}><Server size={14}/> Nodes</div>
                        <div className="d-flex flex-column gap-2">
                          {c.agents.map((a, i) => (
                            <div key={i} className="p-2 rounded bg-dark border border-secondary border-opacity-20 d-flex justify-content-between align-items-center">
                               <div className="text-white font-monospace" style={{fontSize: '11px'}}>{a.host}</div>
                               <div className={`badge ${a.active ? 'bg-info' : 'bg-danger'} text-white border-0`} style={{fontSize:'8px'}}>
                                 {a.active ? 'ONLINE' : 'OFFLINE'}
                               </div>
                            </div>
                          ))}
                          {c.agents.length === 0 && <div className="text-secondary small">No agents</div>}
                          <div className="mt-2 text-info small fw-bold">Total Agents: {c.agents.length}</div>
                        </div>
                      </div>

           
                      <div className="col-md-5 text-start px-4">
                        <div className="text-secondary uppercase fw-bold mb-3 d-flex align-items-center gap-2" style={{ fontSize: '10px' }}><Activity size={14}/> System Activity</div>
                        
                        <div className="mb-4">
                           <div className="d-flex justify-content-between align-items-center mb-2">
                              <span className="text-secondary small">Total Raw Logs:</span>
                              <b className="text-white small">{c.stats.logs.total}</b>
                           </div>
                           <div className="p-2 rounded bg-dark border border-secondary border-opacity-30">
                              <div className="text-info font-monospace" style={{fontSize:'10px'}}>Last Log: {c.stats.logs.last_date}</div>
                              <div className="text-white mt-1 italic truncate" style={{fontSize:'10px'}}>{c.stats.logs.last_title}</div>
                           </div>
                        </div>

                  
                        <div>
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <span className="text-secondary small">AI Security Incidents:</span>
                                <b className="text-white small">{c.stats.incidents.total}</b>
                            </div>
                            <div className="p-2 rounded bg-dark border border-secondary border-opacity-30">
                                
                                <div className="text-info font-monospace" style={{fontSize:'10px'}}>Last Incident: {c.stats.incidents.last_date}</div>
                                <div className="text-white mt-1 italic truncate" style={{fontSize:'10px'}}>{c.stats.incidents.last_title}</div>
                            </div>
                        </div>
                        </div>

                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </main>

      <style>{`
        .hover-bg:hover { background: rgba(255,255,255,0.02) !important; }
        .hover-red:hover { color: #ef4444 !important; }
        .truncate { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 100%; }
        .animate-fadeIn { animation: fadeIn 0.3s ease; }
        @keyframes fadeIn { from { opacity: 0; transform: translateY(-5px); } to { opacity: 1; transform: translateY(0); } }
      `}</style>
    </div>
  );
};

export default SuperAdminPage;